import styled from 'styled-components';

const StyledInnerLink = styled.div`
  margin-top: ${props => props.theme.components_spacing_desk.large}px;
  margin-bottom: ${props => props.theme.components_spacing_desk.xxlarge}px;
  padding-right: 64px;
  text-align: right;
  h3{
    margin-bottom: 40px;
  }
  .gradient-fashion{
    background: linear-gradient(105.88deg, rgba(218, 96, 124, 1), rgba(232, 162, 178, 1) );
    background-clip: text;
    -webkit-background-clip:text;
    color:rgba(0,0,0,1);
    
    transition: color .2s ease-in-out, opacity .5s .1s;
  }
  .gradient-real{
    background: linear-gradient(105.88deg, rgba(215, 48, 50, 1), rgba(244, 160, 127, 1));
    background-clip: text;
    -webkit-background-clip:text;
    color:rgba(0,0,0,1);
    
    transition: color .2s ease-in-out, opacity .5s .2s;
  }
  .gradient-interior{
    background: linear-gradient(105.88deg, #1A60D0, #B9D0E4 );
    background-clip: text;
    -webkit-background-clip:text;
    color:rgba(0,0,0,1);
    
    transition: color .2s ease-in-out, opacity .5s .3s;
  }
  .gradient-cpg{
    background: linear-gradient(105.88deg, #E2B234 , #F4DD63 );
    background-clip: text;
    -webkit-background-clip:text;
    color:rgba(0,0,0,1);
    
    transition: color .2s ease-in-out, opacity .5s .4s;;
  }
  .gradient-more{
    background: linear-gradient(105.88deg, #7244E2 , #C8B5F8 );
    background-clip: text;
    -webkit-background-clip:text;
    color:rgba(0,0,0,1);
    
    transition: color .2s ease-in-out, opacity .5s .5s;
  }
  h3:hover{
    color:rgba(0,0,0,0);
  }
  @media screen and (max-width: 1023px){
    margin-top: ${props => props.theme.components_spacing_tablet.large}px;
    margin-bottom: ${props => props.theme.components_spacing_tablet.xxlarge}px;
    padding-right: 40px;
    h3{
      margin-bottom: 24px;
    }
  }
  @media screen and (max-width: 767px){
    margin-top: ${props => props.theme.components_spacing_mobile.large}px;
    margin-bottom: ${props => props.theme.components_spacing_mobile.xxlarge}px;
    padding-right: 24px;
  }
`;

export {
  StyledInnerLink,
};

